import { defineStore } from "pinia";
import { computed, ref } from "vue";
import {
  useGetFbsCustomerType,
  useGetGasContainers,
} from "@/app/fbs-hub-app/shared/composables";

export const useGasContainerStore = defineStore("GasContainer", () => {
  const isInitiallyFetched = ref<boolean>(false);
  const selectedGasContainerSerialNumber = ref<string>();

  const {
    gasContainers,
    fetchingGasContainersError,
    isFetchingGasContainers,
    onFetchingGasContainers,
  } = useGetGasContainers();

  const { fbsCustomerType } = useGetFbsCustomerType(gasContainers);

  const gasContainerCount = computed(() => gasContainers.value?.length);

  const fetchGasContainers = async () => {
    await onFetchingGasContainers();
    isInitiallyFetched.value = true;

    if (!selectedGasContainer.value && gasContainerCount.value)
      setSelectedGasContainerSerialNumber(gasContainers.value![0].serialNumber);
  };

  const setSelectedGasContainerSerialNumber = (serialNumber: string) => {
    selectedGasContainerSerialNumber.value = serialNumber;
  };

  const selectedGasContainer = computed(() =>
    gasContainers.value.find(
      (container) =>
        container.serialNumber === selectedGasContainerSerialNumber.value,
    ),
  );

  const resetData = () => {
    selectedGasContainerSerialNumber.value = undefined;
    isInitiallyFetched.value = false;
    gasContainers.value = [];
    fetchingGasContainersError.value = undefined;
  };

  return {
    gasContainers,
    selectedGasContainer,
    selectedGasContainerSerialNumber,
    setSelectedGasContainerSerialNumber,
    fetchingGasContainersError,
    isFetchingGasContainers,
    isInitiallyFetched,
    fbsCustomerType,
    gasContainerCount,
    fetchGasContainers,
    resetData,
  };
});
